'use client';

import { useEffect, useState } from 'react';

export function getMatch(query: string) {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.matchMedia ? window.matchMedia(query) : null;
}

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(getMatch(query)?.matches || false);

  useEffect(() => {
    const mediaQuery = getMatch(query);

    function handleMatchChange(e: MediaQueryListEvent) {
      setMatches(e.matches);
    }

    mediaQuery?.addEventListener('change', handleMatchChange);

    return () => {
      mediaQuery?.removeEventListener('change', handleMatchChange);
    };
  }, [query]);

  return matches;
}
